var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "scroll",
      staticClass: "start-widget",
      class: {
        "start-widget--logged-in": _vm.showScreen === "store",
        "start-widget--error": _vm.showScreen === "error",
        "start-widget--more": _vm.showScreen === "result",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "chopstick-loader",
          class: {
            "chopstick-loader--active": _vm.loading,
          },
        },
        [
          _c("img", {
            staticClass: "chopstick-loader__gif",
            attrs: { src: "files/loasia/icons/choploader.gif", alt: "loader" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "start-widget__container" },
        [
          _vm.showScreen === "editzip"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "lo-input",
                    class: { empty: _vm.emptyZip },
                    style: _vm.styleObject,
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.zip,
                          expression: "zip",
                        },
                      ],
                      staticClass: "lo-input__field",
                      attrs: {
                        type: "tel",
                        placeholder: ".",
                        autocomplete: "off",
                        maxlength: "4",
                      },
                      domProps: { value: _vm.zip },
                      on: {
                        keydown: _vm.onZipKeydown,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.zip = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { staticClass: "lo-input__label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("zipwidgetpage.plz")) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "lo-input__error" }, [
                      _vm._v(_vm._s(_vm.$t("zipwidgetpage.falsePostCode"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "lo-smallhint" }, [
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.$t("zipwidgetpage.courierListSlug") },
                    },
                    [_vm._v(_vm._s(_vm.$t("zipwidgetpage.noPostCode")))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "lo-choice-btns" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "lo-choice-btns__single lo-choice-btns__single--radio",
                      class: {
                        "lo-choice-btns__single--active":
                          _vm.deliveryType == "delivery",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.deliveryType = "delivery"
                        },
                      },
                    },
                    [
                      _c("input", {
                        staticClass: "radio",
                        attrs: { type: "radio", id: "delivery" },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "label", attrs: { for: "delivery" } },
                        [_vm._v(_vm._s(_vm.$t("zipwidgetpage.deliveryButton")))]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "lo-choice-btns__single lo-choice-btns__single--radio",
                      class: {
                        "lo-choice-btns__single--active":
                          _vm.deliveryType == "takeaway",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.deliveryType = "takeaway"
                        },
                      },
                    },
                    [
                      _c("input", {
                        staticClass: "radio",
                        attrs: { type: "radio", id: "takeaway" },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "label", attrs: { for: "takeaway" } },
                        [_vm._v(_vm._s(_vm.$t("zipwidgetpage.pickupButton")))]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("OrderButton", {
                  attrs: { text: _vm.$t("zipwidgetpage.orderButton") },
                  on: { click: _vm.onOrder },
                }),
                _vm._v(" "),
                _vm._m(0),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showScreen === "editzip" && _vm.zip === ""
            ? [
                _c("div", { staticClass: "prompt" }, [
                  _c("div", { staticClass: "prompt__text" }, [
                    _vm._v(_vm._s(_vm.$t("zipwidgetpage.promptText"))),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showScreen === "error"
            ? [
                _c("div", { staticClass: "start-widget__error-msg" }, [
                  _c("div", [_vm._v(_vm._s(_vm.$t("zipwidgetpage.error")))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "start-widget__error-msg-text" }, [
                  _vm._v(_vm._s(_vm.errorMsg)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "start-widget__return" },
                  [
                    _c("BackButton", {
                      attrs: { text: _vm.$t("zipwidgetpage.backButton") },
                      on: { click: _vm.goBack },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showScreen === "closed"
            ? [
                _c("div", { staticClass: "start-widget__error-msg" }, [
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("zipwidgetpage.closedText"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "start-widget__error-msg-text" }, [
                  _vm._v(_vm._s(_vm.tempClosedMessage)),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "start-widget__return" },
                  [
                    _c("BackButton", {
                      attrs: { text: _vm.$t("zipwidgetpage.backButton") },
                      on: { click: _vm.onTempClosedClose },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showScreen === "store"
            ? [
                _c("div", { staticClass: "start-widget__welcome" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("zipwidgetpage.hello")) +
                        " " +
                        _vm._s(_vm.accountFirstName)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "lo-widget-table" }, [
                  _c("tbody", { staticClass: "lo-widget-table__body" }, [
                    _c("tr", { staticClass: "lo-widget-table__row" }, [
                      _c("td", { staticClass: "td-first" }, [
                        _vm._v(_vm._s(_vm.$t("zipwidgetpage.yourCourier"))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "td-last" }, [
                        _vm._v(_vm._s(_vm.$t("zipwidgetpage.type"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tr",
                      {
                        staticClass:
                          "lo-widget-table__row lo-widget-table__row--bold",
                      },
                      [
                        _c("td", { staticClass: "td-first" }, [
                          _vm._v(_vm._s(_vm.cartStoreName)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "td-last" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                _vm.cartDeliveryType === "takeaway"
                                  ? "zipwidgetpage.pickupType"
                                  : "zipwidgetpage.deliveryType"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("BackButton", {
                  attrs: { text: _vm.$t("zipwidgetpage.changeButton") },
                  on: { click: _vm.changeStore },
                }),
                _vm._v(" "),
                _c("OrderButton", {
                  attrs: { text: _vm.$t("zipwidgetpage.orderButton") },
                  on: { click: _vm.onContinueOrder },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showScreen === "account"
            ? [
                _c("div", { staticClass: "start-widget__welcome" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("zipwidgetpage.hello")) +
                        " " +
                        _vm._s(_vm.accountFirstName)
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "lo-widget-table" }, [
                  _c("tbody", { staticClass: "lo-widget-table__body" }, [
                    _c("tr", { staticClass: "lo-widget-table__row" }, [
                      _c("td", { staticClass: "td-first" }, [
                        _vm._v(_vm._s(_vm.$t("zipwidgetpage.yourCourier"))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "td-last" }, [
                        _vm._v(_vm._s(_vm.$t("zipwidgetpage.type"))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tr",
                      {
                        staticClass:
                          "lo-widget-table__row lo-widget-table__row--bold",
                      },
                      [
                        _c("td", { staticClass: "td-first" }, [
                          _vm._v(_vm._s(_vm.accountAddress.store.name)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "td-last" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                _vm.cartDeliveryType === "takeaway"
                                  ? "zipwidgetpage.pickupType"
                                  : "zipwidgetpage.deliveryType"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("BackButton", {
                  attrs: { text: _vm.$t("zipwidgetpage.changeButton") },
                  on: { click: _vm.changeStore },
                }),
                _vm._v(" "),
                _c("OrderButton", {
                  attrs: { text: _vm.$t("zipwidgetpage.orderButton") },
                  on: { click: _vm.onAccountOrder },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showScreen === "result"
            ? [
                !_vm.noLocation
                  ? _c("div", { staticClass: "start-widget__welcome" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("zipwidgetpage.moreLocation"))),
                      ]),
                    ])
                  : _vm.deliveryType === "delivery"
                  ? _c("div", { staticClass: "start-widget__welcome" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("zipwidgetpage.noLocation")) +
                          "\n        "
                      ),
                    ])
                  : _vm.deliveryType === "takeaway"
                  ? _c("div", { staticClass: "start-widget__welcome" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("zipwidgetpage.noTakeaway")) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.deliveryType === "delivery"
                  ? _c("div", { staticClass: "order-by-phone" }, [
                      _c(
                        "a",
                        {
                          staticClass: "order-by-phone__text",
                          attrs: {
                            href: _vm.$t("zipwidgetpage.courierListSlug"),
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("zipwidgetpage.allCouriers"))
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "start-widget__return" },
                  [
                    _c("BackButton", {
                      attrs: { text: _vm.$t("zipwidgetpage.backButton") },
                      on: { click: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.noLocation
                  ? _vm._l(_vm.locations, function (location) {
                      return _c(
                        "a",
                        {
                          key: location.store_id,
                          staticClass: "lo-icon-btn lo-icon-btn--sm-icon-text",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onLocationListChoose(location)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "lo-icon-btn__text" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(location.store_name) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("SVGArrowCircle"),
                        ],
                        1
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.noLocation && _vm.deliveryType === "takeaway"
                  ? _c(
                      "div",
                      { staticClass: "order-by-phone" },
                      _vm._l(_vm.locationsOpen, function (location) {
                        return _c(
                          "a",
                          {
                            key: location.store_id,
                            staticClass:
                              "lo-icon-btn lo-icon-btn--sm-icon-text",
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onNoLocationListChoose(location)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "lo-icon-btn__text" }, [
                              _vm._v(
                                "\n              " + _vm._s(location.store_name)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("SVGArrowCircle"),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "roller-driver" }, [
      _c("img", {
        attrs: {
          src: "/files/loasia/icons/roller-driver.svg",
          alt: "roller-driver",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }